import { PModel } from '../../engine.js';

export class ModelNotificationEvent {
  constructor(public readonly target: PModel) {
  }
}
